import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 20,
	viewBox: "0 0 32 20",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			fill: "#fff",
			height: 20,
			rx: 2,
			width: 30,
			x: 1
		}), /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m3 0h26c1.1045695 0 2 .8954305 2 2v2h-30v-2c0-1.1045695.8954305-2 2-2z",
					fill: "#1a1f71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m1 16h30v2c0 1.1045695-.8954305 2-2 2h-26c-1.1045695 0-2-.8954305-2-2z",
					fill: "#f7b600"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m13.0044768 13.6056724 1.0823075-6.97566514h1.7300297l-1.0822086 6.97566514z",
					fill: "#1a1f71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m21.0099706 6.80122335c-.3420678-.14000161-.8800552-.29267445-1.5502388-.29267445-1.7104378 0-2.914453.9466334-2.9244468 2.30214568-.0108845 1.00267524.8591768 1.56185752 1.5151118 1.89512112.6741416.341608.9006366.5602125.8979649.8656611-.0046506.4671872-.5380863.6812588-1.0355045.6812588-.6926452 0-1.0606376-.1053875-1.6295961-.3658173l-.2225371-.1110535-.241931 1.5614454c.4034163.1942922 1.1512752.3629329 1.9274336.3717924 1.8177977 0 2.9989556-.9351984 3.0128085-2.3827058.0062339-.7950938-.454771-1.39774971-1.4531695-1.89532718-.6045803-.32347688-.9756402-.53775451-.9713854-.86514607.0003958-.28989298.3134714-.60028654.9910763-.60028654.5658911-.00947767.9755412.1263002 1.2947517.26805314l.1553504.07973599z",
					fill: "#1a1f71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m23.3136094 11.1325167c.1433776-.4009465.689182-1.94982373.689182-1.94982373-.0100928.01844023.1425859-.40403704.2299582-.66549701l.1167602.60162578s.3319749 1.66497866.4003489 2.01369496zm2.1343366-4.4954012h-1.337003c-.4146966 0-.7251006.1234157-.9067715.57824062l-2.5692188 6.39278878h1.8171051s.2964521-.8599952.3637377-1.0487244c.1981954 0 1.9638469.0036056 2.2158708.0036056.0518494.2434319.2106631 1.0451188.2106631 1.0451188h1.6057493z",
					fill: "#1a1f71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m7.29249904 7.54082893c-.53187822-.32400045-1.13877833-.58450217-1.81747099-.76515409l.02295624-.14453441h2.78987576c.37571054.01545274.67968282.14649175.78427223.58854246l.60626241 3.20520241.18137409.966722 1.69331952-4.75572802h1.8333328l-2.7244703 6.96258192-1.83095799.0011331z",
					fill: "#1a1f71"
				})
			]
		})]
	})
});
export default SvgVisa;
